<template>
  <div>
    <h1 class="dark:text-gray-100">总览</h1>
  </div>
</template>
<script setup lang="ts">

</script>
